import { QueryClient } from '@tanstack/react-query';
import { isApiError } from '@/shared/api/errors';

/**
 * 에러 타입 기반 retry 정책
 *
 * - ApiError.isRetryable이 true인 경우에만 재시도 (5xx, 네트워크 오류)
 * - ValidationError, 401, 403, 404 등은 재시도하지 않음
 * - 알 수 없는 에러는 1회만 재시도
 */
function shouldRetry(failureCount: number, error: unknown, maxRetries: number): boolean {
  if (isApiError(error)) {
    return error.isRetryable && failureCount < maxRetries;
  }
  // 알 수 없는 에러는 1회만 재시도
  return failureCount < 1;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000, // 1m: avoids refetch spam for list/detail
      gcTime: 5 * 60_000, // 5m: keep recent data (formerly cacheTime)
      retry: (failureCount, error) => shouldRetry(failureCount, error, 2),
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      // mutation은 기본적으로 재시도하지 않음, 재시도 가능한 에러만 1회
      retry: (failureCount, error) => shouldRetry(failureCount, error, 1),
    },
  },
});
